var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLightRightCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.876 10.662a.81.81 0 0 0-.014 1.154l3.964 3.73a.608.608 0 0 1 0 .886l-3.964 3.72a.8.8 0 0 0 .024 1.154c.3.302.797.28 1.132-.033l4.486-4.227a1.442 1.442 0 0 0 0-2.113l-4.486-4.239c-.304-.291-.863-.313-1.142-.032z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.998 5C9.98 5 5 9.993 5 16c0 6.018 4.994 11 11.009 11C22.017 27 27 22.018 27 16c0-6.007-4.994-11-11.002-11zm0 1.833c5.09 0 9.156 4.077 9.156 9.167s-4.055 9.167-9.145 9.167S6.843 21.09 6.832 16a9.124 9.124 0 0 1 9.166-9.166z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLightRightCircle);
export default __webpack_public_path__ + "static/media/Chevron-Light_Right-Circle.299beeaedcf24d10ec8deb8b0d04b57a.svg";
export { ForwardRef as ReactComponent };